import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from './material/material.module';
import { ButtonComponent } from './components/button/button.component'
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../core/components/navbar/navbar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { HeaderComponent } from '../plataform/layout/header/header.component';
import { DialogSucessComponent } from './components/dialog-sucess/dialog-sucess.component';
import { BrlCurrencyDirective } from './directives/brl-currency.directive';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DialogExcluirComponent } from './components/dialog-excluir/dialog-excluir.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { StepperStepDirective } from './components/stepper/stepper-step.directive';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';

@NgModule({
  declarations: [
    ButtonComponent,
    NavbarComponent,
    SpinnerComponent,
    HeaderComponent,
    DialogSucessComponent,
    BrlCurrencyDirective,
    PaginationComponent,
    DialogExcluirComponent,
    DialogConfirmComponent,
    StepperComponent,
    StepperStepDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    ButtonComponent,
    NavbarComponent,
    SpinnerComponent,
    HeaderComponent,
    BrlCurrencyDirective,
    PaginationComponent,
    DialogExcluirComponent,
    DialogConfirmComponent,
    StepperComponent,
    StepperStepDirective,
  ],
})
export class SharedModule {}
